<template>
  <main class="content">
    <!-- content -->
    <section class="program-intro">
      <div class='container'>
        <div class="program-intro__wrapper">
          <div class="program-intro__inner" v-if="program.name">
            <div class="program-intro__text">
              <span class="intro__info">Российская общественная некоммерческая организация Экспертный центр ПАУ</span>
              <h1 class="program-intro__title">{{program.name}}</h1>
              <h2 v-if="program.cf && program.cf[315] === '0'" class="program-intro__title" style="color: red">БЕСПЛАТНО!</h2>
              <div class="program-intro__btn-wrapper intro__video" v-if="program.cf[310]">
                <a class="intro__btn" @click="showModal(5,'<iframe src=\'' + replaceUrlYouTube(program.cf[310]) + '\'></iframe>')" target="_blank">
                  <picture><source srcset="/static/assets//img/intro/play.svg" type="image/webp"><img src="/static/assets//img/intro/play.svg" alt="" /></picture>
                  <span>Смотреть видео</span>
                </a>
              </div>
            </div>
            <div class="program-intro__comment">
              <button class="program-intro__btn">Наши эксперты знают как решить ваш вопрос</button>
              <div class="program-intro__head">
                <div class="program-intro__avatar" style="background-image: url('https://smart.v-avtoservice.com/smart/uploads/1606976681_1.jpeg.jpeg');background-size: cover"></div>
                <div class="program-intro__title">
                  <p class="name-user">Наталья Кабанова</p>
                  <p class="post-user">Адвокат</p>
                </div>
              </div>
              <div class="comment-user">
                <div class="program-intro__woks1"></div>
                <div class="program-intro__woks2"></div>
                Член Адвокатской палаты рег. № 78/6987<br/>
                Общий юридический стаж больше 10 лет, в том числе в крупных юридических компаниях и корпорациях России.<br/>
                Высшее юридическое образование:<br/>
                «Российский Новый Университет» 2012 г.<br/>
                Санкт-Петербургский институт адвокатуры
              </div>
            </div>
          </div>
          <div v-if="selectDate.time" class="program-intro__wrapper-schedule wrapper-schedule-intro">
            <h2 class="wrapper-schedule-intro__title">Выбери дату и время</h2>
            <div class="item-schedule-line">
              <slot v-for="(array, date) in timetable">
                <div class="item-schedule-col" :key="date">
                  <p class="item-schedule__date" :key="date">{{array.day}}</p>
                  <div class="item-schedule__info" v-for="(value, id) in array.rows" :key="id">
                    <router-link tag="span" v-if="value.cf[221]" :to="'/' + value.cf[221]" class="item-schedule__img">
                    <picture><source srcset="/static/assets//img/schedule/watch.svg" type="image/webp"><img src="/static/assets//img/schedule/watch.svg" alt="" /></picture>
                  </router-link>
                    <div class="item-schedule__time">{{value.time}}</div>
                    <h3 class="item-schedule__text">{{value.name}}</h3>
                    <div class="item-schedule__btn-wrapper">
                    <button class="item-schedule__btn" data-popup="popup-order" v-if="value.cf[153] !== 'Мест нет'" @click="showModal(33, value.name, value.date + ' ' + value.time, searchWordRegularExpressions(value.cf[155]) || 350)">Записаться</button>
                    <button class="item-schedule__btn" v-else>Мест нет</button>
                    <div class="item-schedule__subtext" v-if="value.cf[155] === '' || value.cf[155] === undefined">Мест нет, смотрите на другую дату</div>
                    <div class="item-schedule__subtext" v-else>{{value.cf[155]}} мест</div>
                  </div>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="learn" v-if="program.cf && program.cf[311] && program.cf[312] && program.cf[313]">
      <div class='container'>
        <div class="learn__wrapper">
          <div class="learn__title">Программа обучения</div>
          <div class="learn__block block-learn">
            <div class="block-learn__item">
              <h3 class="block-learn__title">Программа</h3>
              <p class="block-learn__subtitle" v-html="(program.cf[311]).replace(/\n/g, '<br>')"></p>
            </div>
            <div class="block-learn__item">
              <h3 class="block-learn__title">Что будет</h3>
              <p class="block-learn__subtitle" v-html="(program.cf[312]).replace(/\n/g, '<br>')"></p>
            </div>
            <div class="block-learn__item">
              <h3 class="block-learn__title">Какой результат</h3>
              <p class="block-learn__subtitle" v-html="(program.cf[313]).replace(/\n/g, '<br>')"></p>
            </div>
          </div>
          <div class="learn__hr"></div>
          <div class="learn__free__inf">
            <h3>Полезные материалы - скачай бесплатно</h3>
            <div class="free-inf__download">
              <div class="free-inf__left" @click="showModal(6, `Воркбук. ${(selectDate.name || program.name)}`)">
                <div class="free-inf__ic"></div>
                <div class="free-inf__name">Рабочая книга</div>
                <div class="free-inf__down"></div>
            </div>
              <div class="free-inf__right" @click="showModal(6, 'Бланки ходатайств')">
                <div class="free-inf__ic"></div>
                <div class="free-inf__name">Ходатайства</div>
                <div class="free-inf__down"></div>
            </div>
            </div>
          </div>
          <div class="learn__linear learn-linear" v-if="Object.keys(dates).length">
            <h4 class="learn-linear__title">До старта осталось</h4>
            <div class="learn-linear__watch watch-learn">
              <div class="watch-learn__days">{{days}} <span>{{d}}</span></div>
              <div class="watch-learn__hour">{{hour}} <span>{{h}}</span></div>
              <div class="watch-learn__min">{{minute}} <span>{{m}}</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="choose">
      <div class='container'>
        <div class="choose__wrapper">
          <h1 class="choose__title">Выбрать дату и время</h1>
          <div class="choose__box">
            <div class="choose__select">
              <div v-if="selectDate.time" :class="selectShow?'nice-select select-block open':'nice-select select-block'" @click="selectShow=1" @focusout="selectShow=0" tabindex="0"><span class="current">{{selectDate.time}}</span>
                <ul class="list">
                  <li v-for="date in dates" :key="date.id" :class="selectDate.id===date.id?'option selected focus':'option'" @click="selectDate=date">
                    {{date.time}}</li>
                </ul>
              </div>
              <div class="chose__notTime">
                <div class="notTime-fire"></div>
                <div class="notTime-title" @click="showModal(4, 'Запись. ' + (selectDate.name || program.name), 'Купить запись и решить вопрос прямо сейчас', 599)">Нет времени ждать? Нужно сейчас</div>
                <div class="notTime-array wibro" @click="showModal(4, 'Запись. ' + (selectDate.name || program.name), 'Купить запись и решить вопрос прямо сейчас', 599)"></div>
              </div>
            </div>
          </div>
          <div class="choose__info info-choose">
            <div class="info-choose__items info-choose__items--standart">
              <div class="info-choose__title">
                <span>Стандарт</span>
              </div>
              <ul class="info-choose__list" v-if="program.cf && program.cf[314]">
                <li v-html="(program.cf[314]).replace(/\n/g, '<br>')"></li>
              </ul>
              <ul class="info-choose__list" v-else>
                <li>Онлайн разбор Вашей ситуации</li>
                <li>Решение Вашего вопроса</li>
              </ul>
              <div class="info-choose__footer">
                <p class="info-choose__price" v-if="program.cf && program.cf[631]">{{program.cf[631]}} руб</p>
                <p class="info-choose__price" v-else-if="program.cf && program.cf[315]">{{program.cf[315]}} руб</p>
                <p class="info-choose__price" v-else>350 руб</p>
                <button class="info-choose__btn" @click="showModal(33, (selectDate.name || program.name), selectDate.time, (program.cf && program.cf[631]?parseInt(program.cf[631]):(program.cf && program.cf[315]?parseInt(program.cf[315]):350)))">Записаться</button>
              </div>
            </div>
            <div class="info-choose__items info-choose__items--vip">
              <div class="info-choose__title">
                <span>VIP</span>
              </div>
              <ul class="info-choose__list" v-if="program.cf && program.cf[316]">
                <li v-html="(program.cf[316]).replace(/\n/g, '<br>')"></li>
              </ul>
              <ul class="info-choose__list" v-else>
                <li>Онлайн интенсив 2 часа</li>
                <li>Шаблоны документов</li>
                <li>Консультация</li>
              </ul>
              <div class="info-choose__footer">
                <p class="info-choose__price" v-if="program.cf && program.cf[632]">{{program.cf[632]}} руб</p>
                <p class="info-choose__price" v-else-if="program.cf && program.cf[317]">{{program.cf[317]}} руб</p>
                <p class="info-choose__price" v-else>690 руб</p>
                <button class="info-choose__btn-vip" @click="showModal(33, (selectDate.name || program.name), selectDate.time, (program.cf && program.cf[632]?parseInt(program.cf[632]):(program.cf && program.cf[317]?parseInt(program.cf[317]):690)))">Записаться</button>
              </div>
            </div>
            <div class="info-choose__items">
              <div class="info-choose__title">
                <span>Премиум</span>
              </div>
              <ul class="info-choose__list" v-if="program.cf && program.cf[318]">
                <li v-html="(program.cf[318]).replace(/\n/g, '<br>')"></li>
              </ul>
              <ul class="info-choose__list" v-else>
                <li>Обучение 2 часа</li>
                <li>Шаблоны документов</li>
                <li>Консультация</li>
                <li>Еще одно обучение в подарок</li>
              </ul>
              <div class="info-choose__footer">
                <p class="info-choose__price" v-if="program.cf && program.cf[633]">{{program.cf[633]}} руб</p>
                <p class="info-choose__price" v-else-if="program.cf && program.cf[319]">{{program.cf[319]}} руб</p>
                <p class="info-choose__price" v-else>1900 руб</p>
                <button class="info-choose__btn" @click="showModal(33, (selectDate.name || program.name), selectDate.time, (program.cf && program.cf[633]?parseInt(program.cf[633]):(program.cf && program.cf[319]?parseInt(program.cf[319]):1900)))">Записаться</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
э
    <section class="comment">
      <div class='container'>
        <div class="comment__wrapper">
          <h1 class="comment__title">Отзывы</h1>
          <div class="comment__inner">
            <div class="comment-swiper-container">
              <!-- Additional required wrapper -->
              <div class="comment-swiper-wrapper">
                <!-- Slides -->
                <div class="comment-swiper-slide">
                  <div class="comment__item item-comment">
                    <div class="item-comment__header">
                      <!-- <div class="item-comment__avatar">
                        <picture><source srcset="/static/assets//img/comment/avatar.webp" type="image/webp"><img src="/static/assets//img/comment/avatar.png" alt="" /></picture>
                      </div> -->
                      <div class="item-comment__info">
                        <div class="item-comment__name">
                          Константин
                        </div>
                        <div class="item-comment__city">
                          Москва
                        </div>
                      </div>
                    </div>
                    <div class="item-comment__body">
                      <p>Продуктивная работа получилась. По сути за 1 час дали такую конкретику, которую я сам искал бы неделю точно. Спасибо.Ставлю твердую пятерку!</p>
                    </div>
                    <div class="item-comment__footer">
                      <picture><source srcset="/static/assets//img/comment/1.webp" type="image/webp"><img src="/static/assets//img/comment/1.png" alt="" /></picture>
                      <picture><source srcset="/static/assets//img/comment/2.webp" type="image/webp"><img src="/static/assets//img/comment/2.png" alt="" /></picture>
                    </div>
                  </div>
                </div>
                <div class="comment-swiper-slide">
                  <div class="comment__item item-comment">
                    <div class="item-comment__header">
                      <!-- <div class="item-comment__avatar">
                        <picture><source srcset="/static/assets//img/comment/avatar2.webp" type="image/webp"><img src="/static/assets//img/comment/avatar2.png" alt="" /></picture>
                      </div> -->
                      <div class="item-comment__info">
                        <div class="item-comment__name">
                          Евгений
                        </div>
                        <div class="item-comment__city">
                          Санкт-Петербург
                        </div>
                      </div>
                    </div>
                    <div class="item-comment__body">
                      <p>Был у юриста на бесплатной консультации. За 20 минут и 1200 рублей я не получил и 10% от того что получил на вашем вебинаре. Намного полезней и конкретнее!</p>
                    </div>
                    <div class="item-comment__footer">
                     <!-- <picture><source srcset="/static/assets//img/comment/1.webp" type="image/webp"><img src="/static/assets//img/comment/1.png" alt="" /></picture>
                      <picture><source srcset="/static/assets//img/comment/2.webp" type="image/webp"><img src="/static/assets//img/comment/2.png" alt="" /></picture> -->
                    </div>
                  </div>
                </div>
                <div class="comment-swiper-slide">
                  <div class="comment__item item-comment">
                    <div class="item-comment__header">
                      <!--  <div class="item-comment__avatar">
                        <picture><source srcset="/static/assets//img/comment/avatar3.webp" type="image/webp"><img src="/static/assets//img/comment/avatar3.png" alt="" /></picture>
                      </div> -->
                      <div class="item-comment__info">
                        <div class="item-comment__name">
                          Александр
                        </div>
                        <div class="item-comment__city">
                          Самара
                        </div>
                      </div>
                    </div>
                    <div class="item-comment__body">
                      <p>Участвовал в бесплатном вебинаре по промо-коду. Но могу сказать, что заплатил бы и 350 и 3500 рублей потому что это того реально стоит. Рекомендую</p>
                    </div>
                    <div class="item-comment__footer">
                     <!--  <picture><source srcset="/static/assets//img/comment/1.webp" type="image/webp"><img src="/static/assets//img/comment/1.png" alt="" /></picture>
                      <picture><source srcset="/static/assets//img/comment/2.webp" type="image/webp"><img src="/static/assets//img/comment/2.png" alt="" /></picture> -->
                    </div>
                  </div>
                </div>
                <div class="comment-swiper-slide">
                  <div class="comment__item item-comment">
                    <div class="item-comment__header">
                      <!-- <div class="item-comment__avatar">
                        <picture><source srcset="/static/assets//img/comment/avatar3.webp" type="image/webp"><img src="/static/assets//img/comment/avatar3.png" alt="" /></picture>
                      </div> -->
                      <div class="item-comment__info">
                        <div class="item-comment__name">
                          Светлана
                        </div>
                        <div class="item-comment__city">
                          Москва
                        </div>
                      </div>
                    </div>
                    <div class="item-comment__body">
                      <p>Не в восторге от вебинара, но это помогло мне самой разобраться в том как и что я должна делать. Была у юриста который за то же самое хотел 15000 рублей. Разница есть</p>
                    </div>
                    <div class="item-comment__footer">
                     <!--  <picture><source srcset="/static/assets//img/comment/1.webp" type="image/webp"><img src="/static/assets//img/comment/1.png" alt="" /></picture> -->
                      <picture><source srcset="/static/assets//img/comment/2.webp" type="image/webp"><img src="/static/assets//img/comment/2.png" alt="" /></picture>
                    </div>
                  </div>
                </div>
                <div class="comment-swiper-slide">
                  <div class="comment__item item-comment">
                    <div class="item-comment__header">
                      <!--  <div class="item-comment__avatar">
                        <picture><source srcset="/static/assets//img/comment/avatar3.webp" type="image/webp"><img src="/static/assets//img/comment/avatar3.png" alt="" /></picture>
                      </div> -->
                      <div class="item-comment__info">
                        <div class="item-comment__name">
                          Станислав
                        </div>
                        <div class="item-comment__city">
                          Саратов
                        </div>
                      </div>
                    </div>
                    <div class="item-comment__body">
                      <p>Смутило, что всего 350 рублей. Но с другой стороны и ничем не рискуешь поэтому купил доступ. Проблему только предстоит решать, но по крайней мере я теперь к этому готов.</p>
                    </div>
                    <div class="item-comment__footer">
                     <!--  <picture><source srcset="/static/assets//img/comment/1.webp" type="image/webp"><img src="/static/assets//img/comment/1.png" alt="" /></picture>
                      <picture><source srcset="/static/assets//img/comment/2.webp" type="image/webp"><img src="/static/assets//img/comment/2.png" alt="" /></picture> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
           <div class="swiper-iptions comment-swiper-iptions">
                <div class="comment-swiper-button-prev"></div>
                <div class="comment-swiper-pagination"></div>
                <div class="comment-swiper-button-next"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="program-slide">
      <div class='container'>
        <div class="program-wrapper">
          <h1 class="program-title">Вам может быть полезно</h1>
          <div class="program-inner">
            <div class="program-swiper-container">
              <!-- Additional required wrapper -->
              <div class="program-swiper-wrapper">
                <!-- Slides -->
                <div class="program-swiper-slide program-item" v-for="pr in programs" :key="pr.id" v-if="parseInt(pr.cf[309]) === parseInt(program.cf[309])">
                  <div class="program-item__img">
                        <span>
                            <picture>
                              <img class="program-item__desktop" v-if="pr.cf[338]" :src="pr.cf[338]" />
                            </picture>
                            <picture>
                              <img class="program-item__mobile" v-if="pr.cf[338]" :src="pr.cf[338]" />
                            </picture>
                        </span>
                    <div class="program-item__head">{{pr.name}}</div>
                  </div>
                  <h2 class="program-item__title">{{pr.name}}</h2>
                  <router-link class="program-item__footer" :to="'/smart/group/' + pr.id">
                    Подробнее <span> <picture><source srcset="/static/assets/img/program/arrow.svg" type="image/webp"><img src="/static/assets/img/program/arrow.svg" width="16" height="8" alt="" /></picture> </span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="swiper-iptions program-swiper-iptions">
              <div class="program-swiper-button-prev"></div>
              <div class="program-swiper-pagination"></div>
              <div class="program-swiper-button-next"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <free id="freeProgram" />
  </main>
</template>

<script>
import Swiper from 'swiper/js/swiper'
import axios from '@/router/http'
import Shedule from '@/components/include/shedule'
import moment from 'moment'
import free from './free'
export default {
  name: 'program',
  components: {
    Shedule,
    free
  },
  data () {
    return {
      program: {},
      programs: [],
      timetable: [],
      groupsSmart: [],
      groupsOA: [],
      timer: null,
      days: null,
      hour: null,
      minute: null,
      timeinterval: null,
      date: null,
      d: null,
      h: null,
      m: null,
      selectShow: 0,
      selectDate: {},
      dates: {}
    }
  },
  mounted () {
    axios.get('https://urist2.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
      this.program = response.data
      setTimeout(() => {
        this.initSliderComm()
      }, 1000)
      axios.get('https://urist2.v-avtoservice.com/list/get-lists?id=30').then(response => {
        this.programs = response.data

        setTimeout(() => {
          this.initSliderProg()
        }, 1000)
      })
    })
    axios.get('https://urist2.v-avtoservice.com/list/get-time-table?wheres=' + this.$route.params.id).then(response => {
      this.timetable = response.data
      let id = 0
      Object.values(this.timetable).forEach(days => {
        Object.values(days.rows).forEach(time => {
          let tt = moment(time.dt, 'YYYY-MM-DD HH:mm:ss').format()
          var date = new Date(tt)
          var unixTimeStamp = Math.floor(date.getTime() / 1000)
          var now = Math.floor(new Date().getTime() / 1000)
          if ((this.timer >= unixTimeStamp || this.timer === null) && now < unixTimeStamp) {
            // console.table({
            //   timer: this.timer,
            //   unix: unixTimeStamp,
            //   now: now,
            //   tt: tt
            // })
            this.timer = unixTimeStamp
            this.date = tt
          }
          this.dates[id] = {id: time.id, time: time.date + ' ' + time.time, name: time.name}
          if (id === 0) {
            this.selectDate = {id: time.id, time: time.date + ' ' + time.time, name: time.name}
          }
          id++
        })
      })
      this.initializeClock()
      this.timeinterval = setInterval(() => {
        this.initializeClock()
      }, 30 * 1000)
    })
    axios.get('https://smart.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
      this.program = response.data
      setTimeout(() => {
        this.initSliderComm()
      }, 1000)
      setTimeout(() => {
        this.initSliderProg()
      }, 1000)
    })
    axios.get('https://smart.v-avtoservice.com/list/get-time-table?wheres=' + this.$route.params.id).then(response => {
      this.timetable = response.data
      let id = 0
      Object.values(this.timetable).forEach(days => {
        Object.values(days.rows).forEach(time => {
          let tt = moment(time.dt, 'YYYY-MM-DD HH:mm:ss').format()
          var date = new Date(tt)
          var unixTimeStamp = Math.floor(date.getTime() / 1000)
          var now = Math.floor(new Date().getTime() / 1000)
          if ((this.timer >= unixTimeStamp || this.timer === null) && now < unixTimeStamp) {
            // console.table({
            //   timer: this.timer,
            //   unix: unixTimeStamp,
            //   now: now,
            //   tt: tt
            // })
            this.timer = unixTimeStamp
            this.date = tt
          }
          this.dates[id] = {id: time.id, time: time.date + ' ' + time.time, name: time.name}
          if (id === 0) {
            this.selectDate = {id: time.id, time: time.date + ' ' + time.time, name: time.name}
          }
          id++
        })
      })
      this.initializeClock()
      this.timeinterval = setInterval(() => {
        this.initializeClock()
      }, 30 * 1000)
    })
    axios.get('https://smart.v-avtoservice.com/list/get-lists?id=36').then(response => {
      this.groupsSmart = response.data
    })
    axios.get('https://urist2.v-avtoservice.com/list/get-lists?id=29').then(response => {
      this.groupsOA = response.data
    })
    setTimeout(() => {
      this.initSliderFree()
    }, 1000)
    setTimeout(() => {
      this.referenceModal()
    }, 1500)
  },
  computed: {
    // editYouTubeUrlAdres (e) {
    //   e = 'https://www.youtube.com/watch?v='
    //   let regular = /(бесплат)+/i
    //   if (regular.test(e)) {
    //     return 'https://www.youtube.com/embed/'
    //   }
    // }
  },
  methods: {
    referenceModal () {
      let vm = 1
      if ((window.location.href === 'http://localhost:8080/urist/program/' + this.program.id + '#requestModal4') && vm === 1) {
        $('.notTime-title').trigger('click')
        // console.log('try')
        vm = 2
      }
    },
    replaceBr (init) {
      return init.replace(/\n/g, '<br>')
    },
    getNumEnding (iNumber, aEndings) {
      var sEnding, i
      iNumber = iNumber % 100
      if (iNumber >= 11 && iNumber <= 19) {
        sEnding = aEndings[2]
      } else {
        i = iNumber % 10
        switch (i) {
          case (1): sEnding = aEndings[0]; break
          case (2):
          case (3):
          case (4): sEnding = aEndings[1]; break
          default: sEnding = aEndings[2]
        }
      }
      return sEnding
    },
    getTimeRemaining (endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date())
      var seconds = Math.floor((t / 1000) % 60)
      var minutes = Math.floor((t / 1000 / 60) % 60)
      var hours = Math.floor((t / (1000 * 60 * 60)) % 24)
      var days = Math.floor(t / (1000 * 60 * 60 * 24))
      return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      }
    },
    initializeClock () {
      var t = this.getTimeRemaining(this.date)
      // console.log(t)

      this.days = t.days
      this.hour = ('0' + t.hours).slice(-2)
      this.minute = ('0' + t.minutes).slice(-2)// 1,4,5
      this.d = this.getNumEnding(this.days, ['день', 'дня', 'дней'])
      this.h = this.getNumEnding(this.hour, ['час', 'часа', 'часов'])
      this.m = this.getNumEnding(this.minute, ['минута', 'минуты', 'минут'])
      if (t.total <= 0) clearInterval(this.timeinterval)
    },
    moment (date) {
      moment.lang('ru')
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('LL')
    },
    showModal (id, text, time, price) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
      this.$root.requestModalTime = time
      this.$root.requestModalPrice = price
    },
    searchWordRegularExpressions (e) {
      let regular = /(бесплат)+/i
      return (regular.test(e)) ? 'Бесплатный вэбинар' : false
    },
    replaceUrlYouTube (e) {
      console.log(e)
      e = e.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/')
      return e
    },
    initSliderComm () {
      // eslint-disable-next-line
      var commnet = new Swiper('.comment-swiper-container', {
        pagination: {
          el: '.comment-swiper-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        },
        observer: true,
        wrapperClass: 'comment-swiper-wrapper',
        slideClass: 'comment-swiper-slide',
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 0,
        speed: 800,
        loop: true,
        navigation: {
          nextEl: '.comment-swiper-button-next',
          prevEl: '.comment-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          533: {
            slidesPerView: 1
          },
          560: {
            slidesPerView: 1
          },
          728: {
            slidesPerView: 2
          },
          767: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3
          },
          1292: {
            slidesPerView: 3
          }
        }
      })
    },
    initSliderProg () {
      // eslint-disable-next-line
      var commnet = new Swiper('.program-swiper-container', {
        pagination: {
          el: '.program-swiper-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        },
        observer: true,
        wrapperClass: 'program-swiper-wrapper',
        slideClass: 'program-swiper-slide',
        observeParents: true,
        slidesPerView: 2,
        spaceBetween: 0,
        speed: 800,
        loop: true,
        navigation: {
          nextEl: '.program-swiper-button-next',
          prevEl: '.program-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 5
          },
          533: {
            slidesPerView: 5
          },
          560: {
            slidesPerView: 5
          },
          728: {
            slidesPerView: 5
          },
          767: {
            slidesPerView: 5
          },
          992: {
            slidesPerView: 5
          },
          1292: {
            slidesPerView: 5
          }
        }
      })
    },
    initSliderFree () {
      // eslint-disable-next-line
      var commnet = new Swiper('.youtube-swiper-container', {
        pagination: {
          el: '.youtube-swiper-pagination',
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          }
        },
        autoHeight: true,
        observer: true,
        wrapperClass: 'youtube-swiper-wrapper',
        slideClass: 'youtube-swiper-slide',
        observeParents: true,
        slidesPerView: 5,
        spaceBetween: 0,
        speed: 800,
        loop: true,
        navigation: {
          nextEl: '.youtube-swiper-button-next',
          prevEl: '.youtube-swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          533: {
            slidesPerView: 1
          },
          560: {
            slidesPerView: 1
          },
          728: {
            slidesPerView: 1
          },
          767: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 2
          },
          1292: {
            slidesPerView: 3
          }
        }
      })
    }
  },
  watch: {
    selectDate (val) {
      setTimeout(() => {
        this.selectShow = 0
      }, 100)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/uristProgram.vue